import { nanoidSchema, slugSchema } from '@/utility'
import { z } from 'zod'

export const loginPortalEmailSchema = z.object({
  logo: z.string().default(''),
  logoSize: z.string().default('100'),
  buttonText: z.string().max(50).default('Login'),
  message: z
    .string()
    .max(1000)
    .default('Click to access private documentation hosted by scalar.com'),
  title: z.string().max(100).default('Private Docs'),
  mainColor: z.string().max(100).default('#2a2f45'),
  mainBackground: z.string().max(100).default('#f6f6f6'),
  cardColor: z.string().max(100).default('2a2f45'),
  cardBackground: z.string().max(100).default('#fff'),
  buttonColor: z.string().max(100).default('#fff'),
  buttonBackground: z.string().max(100).default('#0f0f0f'),
})

export type LoginPortalEmail = z.infer<typeof loginPortalEmailSchema>

export const loginPortalPageSchema = z.object({
  /** Title of the page for the HTML Head */
  title: z.string().max(100).default('Scalar Private Docs'),
  /** Description of the page for the HTML Head */
  description: z
    .string()
    .max(500)
    .default('Login to access your documentation'),
  /** Custom HTML for the head of the page */
  head: z.string().default(''),
  /** Script to include in the head of the page */
  script: z.string().default(''),
  /** UID of the team theme to apply to the page */
  theme: z.string().default(''),
  /** Company name used in the header */
  companyName: z.string().max(100).default(''),
  /** Logo of the company used in the header as raw SVG/HTML */
  logo: z.string().default(''),
  /** Link that the logo redirects to when clicking */
  logoURL: z.string().default(''),
  /** Favicon URL or dataURI */
  favicon: z.string().default(''),
  /** Terms link */
  termsLink: z.string().default(''),
  /** Privacy link */
  privacyLink: z.string().default(''),
  /** Title of the form */
  formTitle: z.string().max(100).default('Scalar Private Docs'),
  /** Description of the form */
  formDescription: z
    .string()
    .max(500)
    .default('Login to access your documentation'),
  /** Image of the form */
  formImage: z.string().default(''),
})

export type LoginPortalPage = z.infer<typeof loginPortalPageSchema>

export const loginPortalSchema = z.object({
  uid: nanoidSchema,
  title: z.string().max(200),
  slug: slugSchema,
  email: loginPortalEmailSchema,
  page: loginPortalPageSchema,
})

export type LoginPortalCustomization = z.infer<typeof loginPortalSchema>
